import { OnlineStorage, IStorageUser } from "@tblabs/storage";
import { Div, RefString, Text } from "@tblabs/truffle";


export class UserSectionWhenLoggedIn extends Div
{
    constructor(_storage: OnlineStorage)
    {
        super("user-section");

        const icon = new RefString(_storage.User.Icon || "⚪");
        const name = new RefString(_storage.User.Name || "Unknown");
        const role = new RefString(_storage.User.Role || "Unknown");

        _storage.OnUserChange((u: IStorageUser) =>
        {
            icon.value = u.Icon;
            name.value = u.Name;
            role.value = u.Role;
        });

        this.Append(
            new Text(icon).Class("user-section__avatar"),
            new Div("user-section__info").Append(
                new Text(name).Class("user-section__name"),
                new Text(role).Class("user-section__role")
            )
        );
    }
}
